function createAction(type, preparePayload) {
  function actionCreator() {
    if (preparePayload) {
      const prepared = preparePayload(...arguments);
      if (!prepared) {
        throw new Error('preparePayload did not return an object');
      }
      return {
        type,
        payload: prepared
      };
    }
    return {
      type,
      payload: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
  actionCreator.toString = () => `${type}`;
  actionCreator.type = type;
  actionCreator.match = action => action.type === type;
  return actionCreator;
}
function combineReducers(reducers) {
  const finalReducers = Object.keys(reducers).reduce((finalReducers, key) => {
    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
    return finalReducers;
  }, {});
  return function combination(state, action) {
    let hasChanged = false;
    const nextState = {
      ...state
    };
    Object.keys(finalReducers).forEach(key => {
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    });
    return hasChanged ? nextState : state;
  };
}
export { createAction, combineReducers };